// extracted by mini-css-extract-plugin
module.exports = {"ranking_tag_container":"RankingTag_ranking_tag_container__1qAow","number":"RankingTag_number__T9TDM"};